var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestcall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44712 2C6.81042 2 7.14512 2.19701 7.32142 2.51463L8.54467 4.71803C8.70482 5.00653 8.71232 5.35549 8.56477 5.65064L7.38637 8.00743C7.38637 8.00743 7.72787 9.76318 9.15707 11.1924C10.5863 12.6216 12.3361 12.9572 12.3361 12.9572L14.6926 11.779C14.9879 11.6313 15.3371 11.6389 15.6257 11.7994L17.8354 13.0279C18.1527 13.2043 18.3495 13.5388 18.3495 13.9019V16.4386C18.3495 17.7305 17.1495 18.6635 15.9255 18.2505C13.4115 17.4022 9.50917 15.7871 7.03577 13.3137C4.56232 10.8403 2.94722 6.93793 2.09895 4.42399C1.68594 3.19993 2.61898 2 3.91081 2H6.44712Z",
    fill: "#333333",
    stroke: "#333333",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestcall);
export default __webpack_public_path__ + "static/media/requestcall.86e1d1a8855e7904df97e3543ba4e173.svg";
export { ForwardRef as ReactComponent };